import { EAdaptMode } from '../../modifiers/Adapt';
import { ShapeBuffer } from '../ShapeBuffer';
/**
 *
 * @category Shapes.ShapeBuffer
 * @class Rect
 * @extends {ShapeBuffer}
 */
class Rect extends ShapeBuffer {
    /**
     * Creates an instance of Rect.
     *
     * @param {ShapeBaseSettings} [settings={}]
     * @memberof Rect
     */
    constructor(settings = {}) {
        settings.type = 'Rect';
        settings.shape = Rect.buffer;
        settings.adaptMode = EAdaptMode.None;
        super(settings);
    }
}
Rect.buffer = Float32Array.from([1, 1, -1, 1, -1, -1, 1, -1]);
export { Rect };
//# sourceMappingURL=Rect.js.map